import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { CompanyPaymentConfiguration } from 'src/app/models/CompanyPaymentConfiguration';

@Injectable({
    providedIn: 'root'
})
export class CompanyPaymentConfigurationServiceApi extends Api<CompanyPaymentConfiguration> {
}
